import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/use-i18n'

const Resources: React.FC = () => {
  const { t } = useTranslation()
  const resources = [
    {
      title: t('landing.resources.item1.title'),
      description: t('landing.resources.item1.description'),
      icon: '🤖',
    },
    {
      title: t('landing.resources.item2.title'),
      description: t('landing.resources.item2.description'),
      icon: '📊',
    },
    {
      title: t('landing.resources.item3.title'),
      description: t('landing.resources.item3.description'),
      icon: '✨',
    },
    {
      title: t('landing.resources.item4.title'),
      description: t('landing.resources.item4.description'),
      icon: '🌍',
    },
  ]

  return (
    <div className="min-h-screen">
      <section className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-2xl sm:text-3xl lg:text-5xl xl:text-6xl font-bold mb-4 sm:mb-6 text-white leading-tight">
            {t('landing.resources.title').replace(t('landing.resources.titleHighlight'), '')}<span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">{t('landing.resources.titleHighlight')}</span>
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto mb-8">
            {t('landing.resources.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/signup"
              className="inline-flex justify-center px-8 py-4 rounded-full bg-black hover:bg-black/80 text-white font-semibold transition-all duration-300"
            >
              {t('common.startForFree')}
            </Link>
            <Link
              to="/solutions"
              className="inline-flex justify-center px-8 py-4 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition-all duration-300"
            >
              {t('common.seeSolutions')}
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-16">
          {resources.map((r, i) => (
            <div
              key={i}
              className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-6 sm:p-8 hover:border-white/20 transition-all duration-300"
            >
              <div className="text-4xl mb-4">{r.icon}</div>
              <h2 className="text-xl sm:text-2xl font-bold text-white mb-3">{r.title}</h2>
              <p className="text-white/80 leading-relaxed">{r.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center bg-[#1a1a1a] rounded-2xl p-8 sm:p-12 border border-white/10">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">{t('landing.resources.cta.title')}</h3>
          <p className="text-white/70 mb-6 max-w-xl mx-auto">
            {t('landing.resources.cta.body')}
          </p>
          <Link
            to="/signup"
            className="inline-flex justify-center px-8 py-4 rounded-full bg-black hover:bg-black/80 text-white font-semibold transition-all duration-300"
          >
            {t('common.startForFree')}
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Resources
